<template>
    <div class="content_box nopadding">
        <div class="top fixed_top el_form">
            <div class="title">
                <span>设备生命周期</span>
                <el-tooltip popper-class="shadow" effect="light" placement="bottom-start">
                    <div slot="content">
                        <el-form label-position="left" label-width="100px">
                            <el-form-item label="激活阶段">
                                <span>截止统计日期前30天内，绑定设备激活后，累计清扫次数＜5次的设备</span>
                            </el-form-item>
                            <el-form-item label="活跃阶段">
                                <span>截止统计日期，设备已度过“激活阶段”且仍在活跃，则设备在整个生命周期中所处的阶段，<br>活跃阶段设备数=累计激活设备总数-激活阶段设备数-沉默阶段设备数-流失阶段设备数</span>
                            </el-form-item>
                            <el-form-item label="沉默阶段">
                                <span>截止统计日期，超过30 天但不超过60 天未活跃的设备</span>
                            </el-form-item>
                            <el-form-item label="流失阶段">
                                <span>截止统计日期，连续60天以上未活跃的设备</span>
                            </el-form-item>
                        </el-form>
                    </div>
                    <img class="icon-tip" src="../../../assets/images/ico/ic_tip.png" alt="">
                </el-tooltip> &nbsp;&nbsp;&nbsp;&nbsp;
                <el-select v-model="region" placeholder="请选择" @change="selectChanged" size="small">
                    <el-option label="全部区域" value=""></el-option>
                    <el-option label="美洲数据中心" value="us"></el-option>
                    <el-option label="中国数据中心" value="cn"></el-option>
                    <el-option label="欧洲数据中心" value="eu"></el-option>
                    <el-option label="亚太数据中心" value="ap"></el-option>
                </el-select>&nbsp;&nbsp;
                <el-select v-model="searchData.product_key" placeholder="全部产品" clearable @change="selectChanged"
                    size="small">
                    <el-option v-for="item in productList" :key="item.productKey" :label="item.name"
                        :value="item.productKey"></el-option>
                </el-select>&nbsp;&nbsp;
                <el-date-picker v-model="searchData.time_info" type="date" style="width: 180px;" size="small"
                    :picker-options="pickerOptions()" @change="selectChanged" value-format="yyyy-MM-dd"
                    :clearable="false">
                </el-date-picker>
            </div>
        </div>
        <div class="area">
            <div class="content app-operation">
                <div class="overview">
                    <div class="overview_box">
                        <el-button :class="{ overview_item: true, item_border1: life.create }"
                            @click="choose('create')">
                            <p class="item_title">激活阶段</p>
                            <div class="item_list">
                                <div>
                                    <p>设备总数</p>
                                    <p class="number">{{ formatNumber(detail.create_sum || 0) }}</p>
                                    <p class="compared">
                                        <span>环比</span> &nbsp;
                                        <span :class="parseFloat(detail.create_sum_rate) >= 0 ? 'status2' : 'status1'">
                                            {{ detail.create_sum_rate ? detail.create_sum_rate + '%' : '0%' }}
                                        </span>
                                    </p>
                                </div>
                                <div>
                                    <p>当日新增</p>
                                    <p class="number">{{ formatNumber(detail.create_day || 0) }}</p>
                                    <!-- <p class="compared">
                                        <span>环比</span> &nbsp;
                                        <span :class="parseFloat(detail.create_day_rate) >= 0 ? 'status2' : 'status1'">
                                            {{ detail.create_day_rate ? detail.create_day_rate + '%' : '0%' }}
                                        </span>
                                    </p> -->
                                </div>
                            </div>
                        </el-button>
                        <el-button :class="{ overview_item: true, item_border2: life.active }"
                            @click="choose('active')">
                            <p class="item_title">活跃阶段</p>
                            <div class="item_list">
                                <div>
                                    <p>设备总数</p>
                                    <p class="number">{{ formatNumber(detail.active_sum || 0) }}</p>
                                    <p class="compared">
                                        <span>环比</span> &nbsp;
                                        <span :class="parseFloat(detail.active_sum_rate) >= 0 ? 'status2' : 'status1'">
                                            {{ detail.active_sum_rate ? detail.active_sum_rate + '%' : '0%' }}
                                        </span>
                                    </p>
                                </div>
                                <div>
                                    <p>当日新增</p>
                                    <p class="number">{{ formatNumber(detail.active_day || 0) }}</p>
                                    <!-- <p class="compared">
                                        <span>环比</span> &nbsp;
                                        <span :class="parseFloat(detail.active_day_rate) >= 0 ? 'status2' : 'status1'">
                                            {{ detail.active_day_rate ? detail.active_day_rate + '%' : '0%' }}
                                        </span>
                                    </p> -->
                                </div>
                            </div>
                        </el-button>
                        <el-button :class="{ overview_item: true, item_border3: life.silence }"
                            @click="choose('silence')">
                            <p class="item_title">沉默阶段</p>
                            <div class="item_list">
                                <div>
                                    <p>设备总数</p>
                                    <p class="number">{{ formatNumber(detail.silence_sum || 0) }}</p>
                                    <p class="compared">
                                        <span>环比</span> &nbsp;
                                        <span :class="parseFloat(detail.silence_sum_rate) >= 0 ? 'status2' : 'status1'">
                                            {{ detail.silence_sum_rate ? detail.silence_sum_rate + '%' : '0%' }}
                                        </span>
                                    </p>
                                </div>
                                <div>
                                    <p>当日新增</p>
                                    <p class="number">{{ formatNumber(detail.silence_day || 0) }}</p>
                                    <!-- <p class="compared">
                                        <span>环比</span> &nbsp;
                                        <span :class="parseFloat(detail.silence_day_rate) >= 0 ? 'status2' : 'status1'">
                                            {{ detail.silence_day_rate ? detail.silence_day_rate + '%' : '0%' }}
                                        </span>
                                    </p> -->
                                </div>
                            </div>
                        </el-button>
                        <el-button :class="{ overview_item: true, item_border4: life.loss }" @click="choose('loss')">
                            <p class="item_title">流失阶段</p>
                            <div class="item_list">
                                <div>
                                    <p>设备总数</p>
                                    <p class="number">{{ formatNumber(detail.loss_sum || 0) }}</p>
                                    <p class="compared">
                                        <span>环比</span> &nbsp;
                                        <span :class="parseFloat(detail.loss_sum_rate) >= 0 ? 'status2' : 'status1'">
                                            {{ detail.loss_sum_rate ? detail.loss_sum_rate + '%' : '0%' }}
                                        </span>
                                    </p>
                                </div>
                                <div>
                                    <p>当日新增</p>
                                    <p class="number">{{ formatNumber(detail.loss_day || 0) }}</p>
                                    <!-- <p class="compared">
                                        <span>环比</span> &nbsp;
                                        <span :class="parseFloat(detail.loss_day_rate) >= 0 ? 'status2' : 'status1'">
                                            {{ detail.loss_day_rate ? detail.loss_day_rate + '%' : '0%' }}
                                        </span>
                                    </p> -->
                                </div>
                            </div>
                        </el-button>
                    </div>
                </div>
                <div class="trend" ref="trend">
                    <div class="title">
                        <span>设备趋势</span>
                    </div>
                    <div class="radio_box">
                        <el-radio-group size="small" v-model="data_type" @change="radioChanged">
                            <el-radio-button label="week">7天</el-radio-button>
                            <el-radio-button label="month">30天</el-radio-button>
                        </el-radio-group>
                    </div>
                    <div class="chart_box">
                        <div class="trend_chart" ref="trend_chart"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
import resize from "../../../minxins/resize"
export default ({
    name: 'app-operation',
    mixins: [resize],
    data() {
        return {
            region: '',
            productList: [],
            searchData: {
                product_key: '',
                time_info: '',
            },
            life: {
                active: false,
                create: true,
                silence: false,
                loss: true,
            },
            detail: [],
            trendMonth: [],
            trendWeek: [],
            data_type: 'week',
            resizeTimer: null,
            contentWidth: null,
        }
    },
    watch: {
        contentWidth: function (nW) {
            var trendChart = this.echarts.init(this.$refs.trend_chart);
            trendChart.resize();
        },
    },
    created() {
        this.init()
        this.getIotProductList();
        this.getDeviceLife();
    },
    mounted() {
    },
    activated() {
        window.addEventListener('resize', this.onresize());
    },
    deactivated() {
        window.removeEventListener('resize', this.onresize());
    },
    methods: {
        init() {
            this.region = this.$route.query.region || this.region;
            const start = new Date()
            this.searchData.time_info = this.formDate(start.getTime() - 60 * 60 * 24 * 1000, 'YYYY-MM-DD');
        },
        onresize() {
            clearTimeout(this.resizeTimer);
            this.resizeTimer = setTimeout(() => {
                this.contentWidth = this.$refs['trend'].offsetWidth;
            }, 200);
        },
        selectChanged() {
            this.$router.replace('?region=' + this.region);
            this.getDeviceLife();
        },
        getIotProductList() {
            this.api.getIotProductList().then(data => {
                this.productList = data.data.result;
                this.productList.unshift({ 'productKey': '', 'name': '全部产品' })
            })
        },
        getDeviceLife() {
            this.api.getDeviceLife(this.searchData).then(data => {
                this.detail = data.data.result.detail;
                this.trendMonth = data.data.result.detail_month;
                this.trendWeek = data.data.result.detail_week;
                this.initBarLine();
            })
        },
        pickerOptions() {
            return {
                disabledDate(time) {
                    return time.getTime() > new Date().getTime() - 8.64e7;
                }
            }
        },
        choose(v) {
            if (this.life[v] == false) {
                this.life[v] = true;
            } else {
                this.life[v] = false;
            }
            this.initBarLine();
        },
        radioChanged() {
            this.initBarLine();
        },
        initBarLine() {
            let date = [], active_list = [], create_list = [], silence_list = [], loss_list = [];
            let listData = [];
            if (this.data_type == 'week') {
                listData = this.trendWeek;
            } else {
                listData = this.trendMonth;
            }
            listData.forEach(item => {
                date.push(item.time_info);
                active_list.push(item.active_day || 0);
                create_list.push(item.create_day || 0);
                silence_list.push(item.silence_day || 0);
                loss_list.push(item.loss_day || 0);
            })
            var trendChart = this.echarts.init(this.$refs.trend_chart);
            trendChart.clear();
            trendChart.setOption(this.setBarLineOption(date, active_list, create_list, silence_list, loss_list));
        },
        setBarLineOption(date, active_list, create_list, silence_list, loss_list) {
            let option = {
                color: ['#507FF7','#00D6B9','#F8AF0C','#EB534B'],
                tooltip: {
                    trigger: 'axis'
                },
                title: [{
                    left: 52,
                    text: '日新增设备数',
                    textStyle: {
                        color: '#868998',
                        fontWeight: 'normal',
                        fontSize: 14,
                    }
                }],
                legend: {
                    show: false,
                    selected: {
                        '激活阶段': this.life.create,
                        '活跃阶段': this.life.active,
                        '沉默阶段': this.life.silence,
                        '流失阶段': this.life.loss
                    },
                    data: ['激活阶段', '活跃阶段', '沉默阶段', '流失阶段']
                },
                grid: [{
                    left: 80,
                    right: 40,
                }],
                xAxis: [
                    {
                        type: 'category',
                        boundaryGap: false,
                        axisTick: {
                            show: false
                        },
                        axisLine: {
                            show: false
                        },
                        axisLabel: {
                            margin: 22
                        },
                        data: date
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        axisTick: {
                            show: false
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                width: 1,
                                color: "#E8E9F1"
                            }
                        },

                    }
                ],
                series: [
                    {
                        name: '激活阶段',
                        type: 'line',
                        data: create_list,
                        symbolSize: 0,
                    },
                    {
                        name: '活跃阶段',
                        type: 'line',
                        data: active_list,
                        symbolSize: 0,
                    },
                    {
                        name: '沉默阶段',
                        type: 'line',
                        data: silence_list,
                        symbolSize: 0,
                    },
                    {
                        name: '流失阶段',
                        type: 'line',
                        data: loss_list,
                        symbolSize: 0,
                    },
                ]
            };
            return option;
        }
    }
})
</script>
<style lang="less" scoped>
@import '../../../less/statistics.less';

.title {
    /deep/ .el-select {
        width: 180px !important;
    }

    /deep/ .el-input__inner {
        min-width: 168px;
    }
}

.overview_box {
    .overview_item {
        width: 23%;
        padding: 20px 30px 40px 30px;
        border-radius: 24px;
        box-shadow: 0px 4px 10px 0px rgba(103, 113, 130, 0.1);

        .item_title {
            font-size: 16px;
            font-weight: 600;
            padding-bottom: 40px;
            text-align: left;
        }

        .item_list {
            .flexLayout(space-around, start);
        }
    }

    .item_border1 {
        border: 2px solid #507FF7;
    }

    .item_border2 {
        border: 2px solid #00D6B9;
    }

    .item_border3 {
        border: 2px solid #F8AF0C;
    }

    .item_border4 {
        border: 2px solid #EB534B;
    }

    .status1 {
        color: #00D6B9;
    }

    .status2 {
        color: #EB534B;
    }


    /deep/ .el-button:focus {
        background-color: unset;
    }


}


.trend {
    .trend_chart {
        width: 100%;
        height: 400px;
    }

    .radio_box {
        text-align: right;
    }

    .title {
        font-size: 16px;
    }
}
</style>



// WEBPACK FOOTER //
// src/view/statistics/device/device-lifecycle.vue